import { memo, useCallback, useMemo, useState } from "react";
import { z } from "zod";

import type { InputMaybe } from "@/lib/gql/__generated__/graphql";

import { Button } from "@/components/ui/button/button";
import { TextAreaField } from "@/components/ui/form/fields/text-area-field";

import type { ComponentProps } from "react";

type Props = {
	memoByHost?: InputMaybe<string>;
	//
	onUpdate: (hostMemo: string) => void;
};

type MemoByHost = {
	value: string;
	errorMessage: string;
};

const zodSchema = z.object({
	value: z.string().min(1, "メモを入力してください").max(3000).or(z.literal("")),
});

export const MemoByHostOfBasicInfoCompositions = memo(({ memoByHost: _memoByHost, onUpdate }: Props) => {
	const [memoByHost, setMemoByHost] = useState<MemoByHost>({
		value: _memoByHost ?? "",
		errorMessage: "",
	});

	/**
	 * state の更新
	 */
	const handleChangeMemoByHost = useCallback((value: string) => {
		const result = zodSchema.safeParse({ value });
		const errorMessage = result.error?.errors[0].message || "";

		setMemoByHost({
			value,
			errorMessage,
		});
	}, []);
	/**
	 * メモを更新
	 */
	const handleClickSave = useCallback(() => {
		onUpdate(memoByHost.value);
	}, [memoByHost, onUpdate]);

	const variant = useMemo<ComponentProps<typeof Button>["variant"]>(() => {
		if (memoByHost.errorMessage) return "disabled";

		return "outline";
	}, [memoByHost.errorMessage]);
	const disabled = useMemo(() => {
		if (memoByHost.errorMessage) {
			return true;
		}

		return false;
	}, [memoByHost.errorMessage]);

	return (
		<div className="space-y-4 text-center">
			<TextAreaField
				value={memoByHost.value}
				errorMessage={memoByHost.errorMessage}
				rows={4}
				handleChange={handleChangeMemoByHost}
			/>

			<Button variant={variant} disabled={disabled} type="button" size="sm" onClick={handleClickSave}>
				保存
			</Button>
		</div>
	);
});
